import React from 'react';

import { faArrowToRight } from '@fortawesome/pro-regular-svg-icons/faArrowToRight';
import { faBan } from '@fortawesome/pro-solid-svg-icons/faBan';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faExclamation } from '@fortawesome/pro-solid-svg-icons/faExclamation';
import { faLongArrowLeft } from '@fortawesome/pro-solid-svg-icons/faLongArrowLeft';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';

import { faClock } from '@fortawesome/pro-light-svg-icons/faClock';
import { Decision, DecisionType } from '../constants/decision';
import styles from './styles.module.scss';

export const DecisionIcon = ({
  decision,
  decisionType,
}: {
  decision: Decision;
  decisionType?: DecisionType;
}) => {
  const icon =
    decision === Decision.APPROVED
      ? faCheck
      : decision === Decision.DECLINED
        ? faTimes
        : decision === Decision.RUW
          ? faExclamation
          : decision === Decision.RESCINDED
            ? faBan
            : decision === Decision.WITHDRAWN
              ? faLongArrowLeft
              : decision === Decision.WAIVED
                ? faArrowToRight
                : decision === Decision.POSTPONED
                  ? faClock
                  : null;

  const color =
    decision === Decision.APPROVED
      ? styles.Green
      : decision === Decision.DECLINED
        ? styles.Red
        : decision === Decision.RUW
          ? styles.Orange
          : decision === Decision.RESCINDED
            ? styles.DarkNeutral
            : decision === Decision.WITHDRAWN
              ? styles.Neutral
              : decision === Decision.WAIVED
                ? styles.DarkGreen
                : decision === Decision.POSTPONED
                  ? styles.Orange
                  : styles.Gray;

  // if PIA RUW, update the hover text so that underwriter does not confuse it with engine RUW
  if (decision === Decision.RUW && decisionType === DecisionType.PIA) {
    decision = 'Manual review needed' as Decision;
  }
  return (
    <Box title={decision} className={styles.DecisionIconContainer}>
      <Box className={[styles.DecisionIcon, color].join(' ')}></Box>
      <Box>{icon && <FontAwesomeIcon icon={icon} />}</Box>
    </Box>
  );
};
